import { Divider, Flex, IconButton, Text } from "@chakra-ui/react";
import { Card, formatDate } from "@components/ui-kit";
import { Trans, t } from "@lingui/macro";
import { useInvoiceDetailStore } from "@src/components/modules/invoices/Detail/store";
import { Icon } from "@src/components/ui-kit/Icon";
import { currency } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import { CardTitle } from "./common";

export const PaymentsCard = observer(function PaymentsCard() {
  const store = useInvoiceDetailStore();
  const invoice = store.invoice;

  if (!invoice) return null;

  return (
    <Card>
      <Card.Section>
        <Flex alignItems="center" justify="space-between">
          <CardTitle>{t`Payments`}</CardTitle>
          {store.canEditPayments && (
            <IconButton
              aria-label={t`Edit payments`}
              icon={<Icon name="edit-02" />}
              onClick={store.openMatchPaymentModal}
              size="sm"
              variant="ghost"
            />
          )}
        </Flex>

        {invoice.payments.length === 0 ? (
          <Text>
            <Trans>No payments yet</Trans>
          </Text>
        ) : (
          <>
            <Text fontWeight="bold">
              {currency.formatByCurrency(invoice.totalPaid, invoice.currency)}
            </Text>

            <Divider my="3" />

            {invoice.payments.map((payment) => (
              <Text key={`${payment.id}-${payment.amount}`}>
                {formatDate(new Date(payment.date))}
                {" - "}
                {currency.formatByCurrency(
                  payment.amount,
                  payment.document_currency,
                )}
              </Text>
            ))}
          </>
        )}
      </Card.Section>
    </Card>
  );
});
